import React, { useEffect, useState } from 'react';
import {connect, useSelector} from 'react-redux';
import {bindActionCreators} from "redux";
import {
    Box,
    Button,
    FormGroup,
    IconButton,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Tooltip,
} from "@mui/material";
import {styled} from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';

import {selectOrganisationUsers} from '../../../store/organisation/selectots';
import {selectUserOrganisation} from '../../../store/user/selectors';
import {IOrganisation, IOrganisationProfilePayload, IOrganisationUser} from '../../../common/organisation';
import organisationActions from '../../../store/organisation/actions';
import {CommonState} from '../../../store';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });


type Props = {
    organisation?: IOrganisation;
    fetchProfiles: Function;
    addProfile: Function;
    deleteProfile: Function;
    updateProfile: Function;
    uploadProfiles: Function;
};

const USER_TABLE_CELLS = [
    '№',
    'Имя',
    'Логин',
    'Email',
    '',
];

type UserModalProps = {
    isModalVisible: boolean;
    onClose: Function;
    userToEdit?: IOrganisationProfilePayload['profile'];
}
const UserModalForm = ({
    isModalVisible,
    onClose,
    userToEdit,
}: UserModalProps) => {
    //@ts-expect-error
    const [user, setUser] = useState<{name: string, login: string, email?: string, password?: string, passwordConfirm?: string}>({});
    
    //@ts-expect-error
    const updateUserProp = (props) => {
        const userToUpdate = {
            ...user,
            ...props,
        };
        setUser(userToUpdate);
    }

    const setUserName = (name: string) => updateUserProp({name});
    const setUserLogin = (login: string) => updateUserProp({login});

    const setUserEmail = (email: string) => updateUserProp({email})

    const setUserPassword = (password: string) => updateUserProp({password})
    const setUserPasswordConfirm = (passwordConfirm: string) => updateUserProp({passwordConfirm});

    const handleClose = (saveUser?: boolean) => {
        if (saveUser) {
            onClose(user);
        } else {
            onClose();
        }
        //@ts-expect-error
        setUser({});
    }
    useEffect(() => {
        if (!userToEdit) {
            return;
        }
        setUser(userToEdit);
    }, [userToEdit]);
    return (
        <Modal open={Boolean(isModalVisible)} onClose={() => handleClose()}>
        <Box sx={{
            backgroundColor: '#fff',
            width: '280px',
            p: 3,
            borderRadius: 1,
            top: '50%',
            left: '50%',
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
        }}>
            <Typography component='h3'>Добавить пользователя</Typography>
            <FormGroup sx={{mb: 2, py: 2}}>
                <TextField
                    id="login"
                    label="Имя"
                    variant="outlined"
                    sx={{mb: 2}}
                    value={user?.name || ''}
                    onChange={e => setUserName(e.target.value)}
                />
                {!userToEdit && (<TextField
                    id="login"
                    label="Логин"
                    variant="outlined"
                    sx={{mb: 2}}
                    value={user?.login || ''}
                    onChange={e => setUserLogin(e.target.value)}
                />)}
                <TextField
                    id="email"
                    label="Email"
                    variant="outlined"
                    sx={{mb: 2}}
                    value={user?.email || ''}
                    onChange={e => setUserEmail(e.target.value)}
                />
                {!userToEdit && (
                    <>
                        <TextField
                            id="password"
                            label="Пароль"
                            variant="outlined"
                            sx={{mb: 2}}
                            value={user?.password || ''}
                            onChange={e => setUserPassword(e.target.value)}
                            type="password"
                        />
                        <TextField
                            id="passwordConfirm"
                            label="Повторить пароль"
                            variant="outlined"
                            error={user?.password !== user?.passwordConfirm}
                            value={user?.passwordConfirm || ''}
                            onChange={e => setUserPasswordConfirm(e.target.value)}
                            type="password"
                        />
                    </>
                )}
            </FormGroup>
            <Box sx={{mt: 4, display: 'flex', justifyContent: 'flex-end'}}>
                <Button
                    variant="contained"
                    onClick={() => handleClose(true)}
                    disabled={!Boolean(userToEdit) && Boolean(!user?.password?.length || (user?.password !== user?.passwordConfirm))}
                >
                    Сохранить
                </Button>
                <Button
                    variant="contained"
                    sx={{backgroundColor: 'error.main', marginLeft: 1}}
                    onClick={() => handleClose()}
                >
                    Отмена
                </Button>
            </Box>
        </Box>
    </Modal>
    );
};

const View = ({
    organisation,
    fetchProfiles,
    addProfile,
    deleteProfile,
    updateProfile,
    uploadProfiles,
}: Props) => {
    const users = useSelector((state: CommonState) =>  (
        organisation?.alias 
            ?selectOrganisationUsers(state, organisation?.alias)
            : []
    ));
    const [isNewUserModalVisible, setNewUserModalVisibility] = useState<boolean>(false);
    const [userToDelete, setUserToDelete] = useState<string| null>();
    const [userToEdit, setUserToEdit] = useState<IOrganisationProfilePayload['profile'] | null>();
    //@ts-expect-error
    const handleAddUser = (newUser) => {
        if (newUser) {
            addProfile({
                alias: organisation?.alias,
                profile: {
                    login: newUser.login,
                    password: newUser.password,
                    email: newUser.email ?? undefined,
                    name: newUser.name,
                }
            });
        }
        setNewUserModalVisibility(false);
    };

    //@ts-expect-error
    const handleEditUser = (userToUpdate) => {
        if (userToUpdate) {
            updateProfile({
                //@ts-expect-error
                id: userToEdit.id,
                name: userToUpdate.name,
                email: userToUpdate.email,
            })
        }
        setUserToEdit(null);
    }

    const handleDeleteUser = (deleteUser?: boolean) => {
        if (deleteUser && userToDelete) {
            deleteProfile({alias: organisation?.alias, userId: userToDelete});
        }
        setUserToDelete(null);
    }

    useEffect(() => {
        if (organisation?.users) {
            return;
        }
        if (organisation?.alias) {
            fetchProfiles(organisation.alias);
        }
    }, [organisation]);
    //@ts-expect-error
    const onFileUpload = (file) => {
        if (!file) {
            return;
        }
        const form = new FormData();
        form.append('file', file);
        uploadProfiles({alias: organisation?.alias, file: form});
    }
    return (
        <>
            <Paper sx={{p: 2}}>
                <Typography
                    component='h2'
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '1.5rem',
                        color: '#507ebc',
                    }}
                >
                    Пользователи
                </Typography>
                <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    sx={{my: 3}}
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                    >
                    Загрузить CSV файл с пользователями
                    <VisuallyHiddenInput type="file" onChange={(e) => onFileUpload(e.target.files?.length &&  e.target.files[0])}/>
                </Button>
                <TableContainer component={Box} sx={{mb: 4}}>
                    <Table
                        sx={{minWidth: '200px'}}
                    >
                        <TableHead>
                            <TableRow>
                                {USER_TABLE_CELLS.map((cell) => (
                                <TableCell key={cell}>{cell}</TableCell>
                                ))} 
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users?.map((user: IOrganisationUser, index: number) => (
                                <TableRow key={user.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{user.name}</TableCell>
                                    <TableCell>{user.login}</TableCell>
                                    <TableCell>{user.email || ''}</TableCell>
                                    <TableCell>
                                        <Tooltip title="Редактировать пользователя">
                                            <IconButton
                                                color='primary'
                                                size='large'
                                                onClick={() => {
                                                    const selectedUser = users.find((rawUser: IOrganisationUser) => rawUser.id === user.id);
                                                    setUserToEdit({
                                                        name: selectedUser.name,
                                                        login: selectedUser.login,
                                                        email: selectedUser.email,
                                                        //@ts-expect-error
                                                        id: selectedUser.id,
                                                        password: '',
                                                    })
                                                }}>
                                                <EditIcon color='primary' />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Удалить пользователя">
                                            <IconButton color='primary' size='large' onClick={() => setUserToDelete(user.id)}>
                                                <DeleteForeverIcon color='primary' />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <Tooltip title="Добавить пользователя">
                <IconButton color='primary'
                    sx={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '15px',
                    }}
                    size='large'
                    onClick={() => setNewUserModalVisibility(true)}
                >
                    <AddCircleIcon fontSize='large'/>
                </IconButton>
            </Tooltip>
            <UserModalForm isModalVisible={isNewUserModalVisible} onClose={handleAddUser}/>
            <Modal open={Boolean(userToDelete)} onClose={() => handleDeleteUser(false)}>
                <Box sx={{
                        backgroundColor: '#fff',
                        width: '280px',
                        p: 4,
                        borderRadius: 1,
                        top: '50%',
                        left: '50%',
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                    }}>
                        <Typography
                            component='h2'
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                color: '#507ebc',
                            }}
                        >
                            Вы точно хотите удалить пользователя?
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                marginX: 'auto',
                                display: 'block',
                                marginTop: 2,
                                width: '100%',
                                p: 2
                            }}
                            onClick={() =>  handleDeleteUser(true)}
                        >
                          Да 
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                marginX: 'auto',
                                display: 'block',
                                marginTop: 2,
                                width: '100%',
                                p: 2,
                                backgroundColor: 'error.main',
                            }}
                            onClick={() =>  handleDeleteUser()}
                        >
                          Нет
                        </Button>
                    </Box>
            </Modal>
            <UserModalForm
                isModalVisible={Boolean(userToEdit)}
                onClose={handleEditUser}
                //@ts-expect-error
                userToEdit={userToEdit}
            />
        </>
    )
};

//@ts-expect-error
const mapStateToProps = (state) => ({
    organisation: selectUserOrganisation(state), 
})

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    uploadProfiles: bindActionCreators(organisationActions.uploadProfiles, dispatch),
    updateProfile: bindActionCreators(organisationActions.updateProfile, dispatch),
    fetchProfiles: bindActionCreators(organisationActions.getOrganisationProfiles, dispatch),
    addProfile: bindActionCreators(organisationActions.addProfile, dispatch),
    deleteProfile: bindActionCreators(organisationActions.deleteProfile, dispatch),
})


export default connect(mapStateToProps, dispatchProps)(View);